<p-toast></p-toast>
<div style="background-color: rgb(0, 152, 223); height: 5px;" class="ng-star-inserted"></div>
<div class="container">
  <div class="alterar">
    <button pButton type="button" icon="pi pi-pencil" label="Editar" class="p-button-secondary"
      style="height: 34px; margin-left: -2px; margin-right: -6px;"
      (click)="editarParamVisivel=false; salvarCancelarParam=true; habilitar=false;"
      *ngIf="editarParamVisivel"></button>

    <button pButton type="button" icon="pi pi-save" label="Salvar" class="p-button-secondary"
      style="height: 34px; width: 96px; margin-left: -2px;" (click)="salvarParametros()"
      *ngIf="salvarCancelarParam"></button>

    <button pButton type="button" icon="pi pi-ban" label="Cancelar" class="p-button-secondary"
      style="height: 34px; margin-left: -8px;" (click)="cancelar()" *ngIf="salvarCancelarParam"></button>
  </div>
  <div id="titulos">
    <p style="font-size: 21px;"><strong>PARÂMETROS DE SEGURANÇA</strong></p>
  </div>
  <div>
    <div>
      <div id="param">
        <div style="position:absolute; margin-left:536px; width: 229px;">
          <p-checkbox label="Expiração de Senha" [binary]="true" [(ngModel)]="checkbox.expire" [disabled]="habilitar"
            (onChange)="ocultarDiv($event)"></p-checkbox>
          <div id="divExpirarSenha">
            <a id="a">Expira após quantos dias?</a>
            <input id="day" type="number" class="form-control form-control-sm" [disabled]="habilitar"
              [(ngModel)]="model.day">
            <label for="day" style="position:absolute; margin-left:277px; margin-top:-20px;">dias</label>
          </div>
        </div>
        <p-checkbox label="Autenticação de Dois Fatores" [binary]="true" [(ngModel)]="checkbox.authentic" [disabled]="habilitar"></p-checkbox>
        <p-checkbox class="politicaSenha" label="Política de Senha" [binary]="true" [(ngModel)]="checkbox.politics" [disabled]="habilitar"
          (onChange)="ocultarDiv($event)"></p-checkbox>
        <div id="divOculta">
          <div>
            <p-checkbox label="Caracteres Especiais" [binary]="true" [(ngModel)]="checkbox.especialChars"
              [disabled]="!checkbox.politics || habilitar" (onChange)="habilitarTodos($event)">
            </p-checkbox>
          </div>
          <div style="width: 248px;">
            <p-checkbox label="Letras Maiúsculas e Minusculas" [binary]="true" [(ngModel)]="checkbox.letters"
              [disabled]="!checkbox.politics || habilitar" (onChange)="habilitarTodos($event)">
            </p-checkbox>
          </div>
          <div>
            <p-checkbox label="Números" [binary]="true" [(ngModel)]="checkbox.numbers"
              [disabled]="!checkbox.politics || habilitar" (onChange)="habilitarTodos($event)">
            </p-checkbox>
          </div>
          <div>
            <p-checkbox label="Todos" [binary]="true" [(ngModel)]="checkbox.all"
              [disabled]="!checkbox.politics || habilitar" (onChange)="habilitaTodasPoliticas($event)">
            </p-checkbox>
          </div>
        </div>
      </div>
      <div class="confianca">
        <a>Período de confiabilidade do dispositivo:</a>
        <input id="expiracao" type="number" class="form-control form-control-sm" [disabled]="habilitar"
          [(ngModel)]="model.expiracao">
        <a style="position:absolute; margin-left: 382px; margin-top: -20px;">dias</a>
        <button pButton icon="pi pi-ban" label="Revogar Acesso de Todos" class="p-button-secondary"
          style="position:absolute; margin-left:538px; margin-top:-40px;" (click)="revogarAcesso()"></button>
      </div>
    </div>
  </div>

  <div style="margin-top: 38px">
    <button pButton type="button" icon="pi pi-pencil" label="Editar" class="p-button-secondary"
      style="height: 34px; margin-left: 21px; margin-right: -6px;"
      (click)="editarEmailVisivel=false; salvarCancelarEmail=true; habilitarEmail=false"
      *ngIf="editarEmailVisivel"></button>

    <button pButton type="button" icon="pi pi-save" label="Salvar" class="p-button-secondary"
      style="height: 34px; width: 96px; margin-left: 22px;" (click)="salvarEmail()"
      *ngIf="salvarCancelarEmail"></button>

    <button pButton type="button" icon="pi pi-ban" label="Cancelar" class="p-button-secondary"
      style="height: 34px; margin-left: -8px;" (click)="cancelarEmail()" *ngIf="salvarCancelarEmail"></button>
  </div>
  <div id="titulos" style="margin-top: 15px;">
    <p style="font-size: 21px;"><strong>CADASTRO DE REMETENTE PARA ENVIO DE EMAIL</strong></p>
  </div>
  <div style="margin-left: 13px;">
    <div class="usuario">
      <label class="control-label">Email:</label>
      <input id="user" class="form-control form-control-sm" type="text" placeholder="Email" name="username"
        [(ngModel)]="model.username" [disabled]="habilitarEmail" />
    </div>
    <div class="divHost">
      <label class="control-label">Host:</label>
      <input id="host" class="form-control form-control-sm" type="text" placeholder="Host" [(ngModel)]="model.host"
        [disabled]="habilitarEmail" />
    </div>
    <div class="senha">
      <label class="control-label">Senha:</label>
      <input id="password" class="form-control form-control-sm" [type]="tipoVisualizacao" placeholder="Senha"
        [(ngModel)]="model.password" [disabled]="habilitarEmail">
    </div>
    <div class="divPorta">
      <label class="control-label">Porta:</label>
      <input id="porta" class="form-control form-control-sm" type="text" placeholder="Porta" [(ngModel)]="model.porta"
        [disabled]="habilitarEmail" />
    </div>
    <div id="divTipoAutenticacao" class="grid">
      <p>Tipo de Autenticação:</p>
      <div style="margin-top: -8px;">
        <p-dropdown [options]="autenticacoes" [(ngModel)]="selectedAutenticacao" optionLabel="name"
          [disabled]="habilitarEmail"></p-dropdown>
      </div>
    </div>
    <button id="testar" class="btn btn-primary" (click)="enviarEmailTeste()">
      <i id="icon" class="fa fa-envelope"></i>
      Testar E-mail
    </button>
  </div>
</div>